module.exports = __webpack_public_path__ + "static/mysa-mattress-1-9c23714a74490311269efb6ee5a8c49f.mp4";